module.exports = __webpack_public_path__ + "c81e4da0eaa50a3dfeb75f70761bad8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/tr.png
// module id = 1056
// module chunks = 0